
import { DocumentContentEditor } from "./DocumentContentEditor";

interface OrgChartViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function OrgChartView({ content, documentId, onUpdate }: OrgChartViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Company Overview</h2>
        <DocumentContentEditor
          section="Company Overview"
          content={content.companyOverview}
          documentId={documentId}
          field="companyOverview"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Executive Leadership</h2>
        <DocumentContentEditor
          section="Executive Leadership"
          content={content.executiveLeadership}
          documentId={documentId}
          field="executiveLeadership"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Department Structure</h2>
        <DocumentContentEditor
          section="Department Structure"
          content={content.departmentStructure}
          documentId={documentId}
          field="departmentStructure"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Reporting Relationships</h2>
        <DocumentContentEditor
          section="Reporting Relationships"
          content={content.reportingRelationships}
          documentId={documentId}
          field="reportingRelationships"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Key Roles & Responsibilities</h2>
        <DocumentContentEditor
          section="Key Roles & Responsibilities"
          content={content.keyRolesResponsibilities}
          documentId={documentId}
          field="keyRolesResponsibilities"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Growth Planning</h2>
        <DocumentContentEditor
          section="Growth Planning"
          content={content.growthPlanning}
          documentId={documentId}
          field="growthPlanning"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
